import {
  MOBILE_BOTTOM_NAV_HEIGHT_PX,
  MOBILE_HEADER_HEIGHT_PX,
  mobileBottomNavHeightCss,
  mobileContentBottomPad,
} from "../../theme/mobileLayout";

/** Fixed AppBar height (desktop). Mobile uses MOBILE_HEADER_HEIGHT_PX via Toolbar. */
export const FIXED_HEADER_OFFSET_PX = 56;

/** Prefer MOBILE_HEADER_HEIGHT_PX when computing mobile sheet/viewport offsets. */
export const FIXED_MOBILE_HEADER_OFFSET_PX = MOBILE_HEADER_HEIGHT_PX;

/** CSS length for top offset / height calculations under the fixed header. */
export const FIXED_HEADER_OFFSET = `${FIXED_HEADER_OFFSET_PX}px`;

/** @deprecated Bottom nav removed — kept at 0 for import safety. */
export const FIXED_BOTTOM_NAV_OFFSET_PX = MOBILE_BOTTOM_NAV_HEIGHT_PX;

/** CSS length for bottom inset (safe area only). */
export const FIXED_BOTTOM_NAV_OFFSET = mobileBottomNavHeightCss;

/** Page content bottom padding (safe-area only; no bottom nav). */
export const MOBILE_MAIN_BOTTOM_PAD = mobileContentBottomPad;
